import { Box, CircularProgress } from "@mui/material";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../data/providers/AuthProvider";

const PrivateRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress sx={{ height: 200, width: 200 }} />
      </Box>
    );
  }

  return user ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
